import { Component, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'app-mini-paginator',
  templateUrl: './mini-paginator.component.html',
  styleUrls: ['./mini-paginator.component.scss']
})
export class MiniPaginatorComponent implements OnChanges {
  @Input() limit = 10;
  @Input() totalRecords = 0;
  @Input() currentPage = 0;
  @Output() newItemEvent = new EventEmitter();
  screenWidth: number;
  oldLimit = 0;
  miniCurrentPage = 0;
  totalPages = [1];
  pagesRows = [10, 25, 50, 100];
  constructor() {
      this.screenWidth = window.innerWidth;
  }
  ngOnChanges(): void {
    let total = Math.ceil(this.totalRecords / this.limit);

    if (total === 0){
      total = 1;
    }
    this.totalPages.splice(0, this.totalPages.length);
    for (let i = 0; i < total; i++){
      this.totalPages.splice(i, 0, i + 1);
    }

    this.oldLimit = this.limit;
    this.miniCurrentPage = this.currentPage / this.limit + 1 ;
  }

  miniSearch(): void{
    const oldFirst = (this.miniCurrentPage - 1) * this.oldLimit;

    const params = {
      first: Math.floor(oldFirst / this.limit) * this.limit,
      rows: this.limit
    };

    this.newItemEvent.emit(params);
  }

  @HostListener('window:resize', ['$event.target'])
  widthIsMd(event: Window): void {
    this.screenWidth = event.innerWidth;
  }

  get isMd(): boolean {
    return this.screenWidth > 980;
  }
}
